function getPricing(day: App.CalendarDay, includesFlights: boolean): App.Pricing | undefined {
  return includesFlights ? day.pricingWithFlights : day.pricing
}

function getMemberPricing(day: App.CalendarDay, includesFlights: boolean): App.Pricing | undefined {
  return includesFlights ? day.memberPricingWithFlights : day.memberPricing
}

export interface CalendarMonthImpressionPrice {
  memberPrice?: number
  nonMemberPrice: number
}

export function getCalendarMonthImpressionPrice(
  days: Array<App.CalendarDay>,
  includesFlights: boolean,
  displayMemberPrice: boolean,
): CalendarMonthImpressionPrice | undefined {
  let cheapestDay: App.CalendarDay | undefined
  let cheapestDisplayPrice: number | undefined

  days.forEach(day => {
    const pricing = getPricing(day, includesFlights)
    if (!pricing) return

    const memberPricing = getMemberPricing(day, includesFlights)
    const displayPrice = displayMemberPrice && memberPricing ? memberPricing.price : pricing.price
    if (cheapestDisplayPrice === undefined || displayPrice < cheapestDisplayPrice) {
      cheapestDay = day
      cheapestDisplayPrice = displayPrice
    }
  })

  if (!cheapestDay) return undefined

  const pricing = getPricing(cheapestDay, includesFlights)
  if (!pricing) return undefined

  const memberPricing = getMemberPricing(cheapestDay, includesFlights)
  return {
    memberPrice: memberPricing?.price,
    nonMemberPrice: pricing.price,
  }
}
